// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticketCreation {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  background: #f5f7fa;
  color: #333;
  overflow-y: hidden;
  letter-spacing: normal;
  min-height: 100vh;
}

/* Override internal col-md-6 inside FormikSelectField ONLY in this component */
.ticketCreation .col-md-6 {
  max-width: 33.333%;
}

/* Reduce spacing */
.ticketCreation .form-group {
  margin-bottom: 10px;
}

.attachments-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 10px;
}

.attachment-card {
    display: inline-flex;          /* auto width based on content */
    flex-direction: column;
    background: var(--color-bg-hover);
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    padding: 5px 10px;
    margin-right: 12px;
    margin-bottom: 12px;
    position: relative;
    max-width: 100%;               /* prevents overflow outside container */
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.attachment-info {
    padding-right: 30px; /* reserve space for delete icon */
    word-break: break-word; /* long file names wrap safely */
    white-space: normal;
}

.file-name {
    font-size: 13px;
    font-weight: 600;
    color:var(--color-primary-green);
    word-break: break-word;
}

.file-size {
    font-size: 11px;
    color: #777;    
    margin-top: 4px;
    margin-left:7px ;
}

.delete-icon {
    position: absolute;
    top: 5px;
    right: 10px;
    font-size: 13px;
    color: red;
    cursor: pointer;
}

.dropzone {
    border: 2px dashed var(--color-primary-green);
    border-radius: 10px;
    padding: 25px;
    text-align: center;
    background: #f8f9ff;
    transition: 0.2s ease-in-out;
}

.dropzone:hover {
    background: #eef4ff;
    border-color:var(--color-primary-green);
}

.drag-text {
    font-size: 14px;  
    font-weight: 500;
}

.or-text {
    font-size: 12px;
    color: #777;
    margin: 5px 0 15px 0;
}

/* Hide dropdown by default */
.overflow-menu {
  display: none;
}

/* Show dropdown on hover */
.overflow-wrapper:hover .overflow-menu {
  display: block;
}
.workflow-nav-btn {
  background: transparent;
  color: #000;
  border: 1px solid var(--color-primary-orange);
  border-radius: 6px;
  padding: 6px 14px;
}`, "",{"version":3,"sources":["webpack://./src/containers/ticketing/ticketcreation/components/TicketCreation.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oBAAoB,WAAW,gCAAgC;IAC/D,sBAAsB;IACtB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe,gBAAgB,wCAAwC;IACvE,qCAAqC;AACzC;;AAEA;IACI,mBAAmB,EAAE,kCAAkC;IACvD,sBAAsB,EAAE,gCAAgC;IACxD,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,6CAA6C;IAC7C,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,oBAAoB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,6CAA6C;EAC7C,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".ticketCreation {\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-size: 14px;\r\n  background: #f5f7fa;\r\n  color: #333;\r\n  overflow-y: hidden;\r\n  letter-spacing: normal;\r\n  min-height: 100vh;\r\n}\r\n\r\n/* Override internal col-md-6 inside FormikSelectField ONLY in this component */\r\n.ticketCreation .col-md-6 {\r\n  max-width: 33.333%;\r\n}\r\n\r\n/* Reduce spacing */\r\n.ticketCreation .form-group {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.attachments-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 12px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.attachment-card {\r\n    display: inline-flex;          /* auto width based on content */\r\n    flex-direction: column;\r\n    background: var(--color-bg-hover);\r\n    border: 1px solid #dcdcdc;\r\n    border-radius: 8px;\r\n    padding: 5px 10px;\r\n    margin-right: 12px;\r\n    margin-bottom: 12px;\r\n    position: relative;\r\n    max-width: 100%;               /* prevents overflow outside container */\r\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\r\n}\r\n\r\n.attachment-info {\r\n    padding-right: 30px; /* reserve space for delete icon */\r\n    word-break: break-word; /* long file names wrap safely */\r\n    white-space: normal;\r\n}\r\n\r\n.file-name {\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    color:var(--color-primary-green);\r\n    word-break: break-word;\r\n}\r\n\r\n.file-size {\r\n    font-size: 11px;\r\n    color: #777;    \r\n    margin-top: 4px;\r\n    margin-left:7px ;\r\n}\r\n\r\n.delete-icon {\r\n    position: absolute;\r\n    top: 5px;\r\n    right: 10px;\r\n    font-size: 13px;\r\n    color: red;\r\n    cursor: pointer;\r\n}\r\n\r\n.dropzone {\r\n    border: 2px dashed var(--color-primary-green);\r\n    border-radius: 10px;\r\n    padding: 25px;\r\n    text-align: center;\r\n    background: #f8f9ff;\r\n    transition: 0.2s ease-in-out;\r\n}\r\n\r\n.dropzone:hover {\r\n    background: #eef4ff;\r\n    border-color:var(--color-primary-green);\r\n}\r\n\r\n.drag-text {\r\n    font-size: 14px;  \r\n    font-weight: 500;\r\n}\r\n\r\n.or-text {\r\n    font-size: 12px;\r\n    color: #777;\r\n    margin: 5px 0 15px 0;\r\n}\r\n\r\n/* Hide dropdown by default */\r\n.overflow-menu {\r\n  display: none;\r\n}\r\n\r\n/* Show dropdown on hover */\r\n.overflow-wrapper:hover .overflow-menu {\r\n  display: block;\r\n}\r\n.workflow-nav-btn {\r\n  background: transparent;\r\n  color: #000;\r\n  border: 1px solid var(--color-primary-orange);\r\n  border-radius: 6px;\r\n  padding: 6px 14px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
